import {Component, input} from '@angular/core';
import {IconsComponent} from '../icons/icons.component';
import {ISearchStep} from '../../../types/ISearchProgress';

@Component({
  selector: 'app-loading-overlay',
  imports: [
    IconsComponent
  ],
  templateUrl: './loading-overlay.html',
  styleUrl: './loading-overlay.css'
})
export class LoadingOverlay {
  message = input<string>('Loading');
  icon = input<string>('tire');
  steps = input<ISearchStep[]>([]);

  formatDuration(durationMs: number | undefined): string {
    if (durationMs == null) return '';

    const seconds = durationMs / 1000;
    return seconds < 1 ? '<1s' : `${seconds.toFixed(1)}s`;
  }
}
